import voyaLogo from '/voya-logo.jpeg';

const LoadingScreen = () => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background">
      {/* Logo with pulse animation */}
      <div className="relative mb-8">
        <div className="absolute inset-0 bg-primary/20 rounded-full blur-xl animate-pulse" />
        <img
          src={voyaLogo}
          alt="Voya"
          className="relative w-16 h-16 rounded-full object-cover animate-[pulse_2s_cubic-bezier(0.4,0,0.6,1)_infinite]"
        />
      </div>

      {/* Loading dots */}
      <div className="flex items-center gap-1.5">
        <span className="w-2 h-2 bg-primary rounded-full animate-[bounce_1s_ease-in-out_infinite]" style={{ animationDelay: '0ms' }} />
        <span className="w-2 h-2 bg-primary rounded-full animate-[bounce_1s_ease-in-out_infinite]" style={{ animationDelay: '150ms' }} />
        <span className="w-2 h-2 bg-primary rounded-full animate-[bounce_1s_ease-in-out_infinite]" style={{ animationDelay: '300ms' }} />
      </div>

      {/* Subtle text */}
      <p className="mt-4 text-sm text-muted-foreground animate-pulse">
        Preparing your journey...
      </p>
    </div>
  );
};

export default LoadingScreen;
